import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

import type { CsatEligibilityData } from './CsatEligibilityData';
import { STORAGE_KEY } from './STORAGE_KEY';

export const writeToStorage = (data: CsatEligibilityData): void => {
	try {
		AtlBrowserStorageLocal.setItem(STORAGE_KEY, JSON.stringify(data));
	} catch {
		// Best-effort: storage might be denied (no consent) or full.
	}
};
